export const DEFAULT_ENDPOINTS = {
  list: 'wo-sf-task-list',
  mark: 'wo-sf-task-mark'
}

export const DEFAULT_POLICY = 'wealthOwners'
export const DEFAULT_TAG = 'live'

export function buildSeCode (endpoint, suffix) {
  return `se:${endpoint}:${suffix}`
}

export const DEFAULT_COLUMNS = ['type', 'status', 'subject', 'dueDate']

export const AVAILABLE_COLUMNS = [
  { key: 'type', label: 'Type', defaultHeader: 'Type' },
  { key: 'status', label: 'Status Icon', defaultHeader: '' },
  { key: 'subject', label: 'Subject', defaultHeader: 'Task' },
  { key: 'dueDate', label: 'Due Date', defaultHeader: 'Due' },
  { key: 'priority', label: 'Priority', defaultHeader: 'Priority' },
  { key: 'createdDate', label: 'Created Date', defaultHeader: 'Created' },
  { key: 'description', label: 'Description', defaultHeader: 'Description' },
  { key: 'codeName', label: 'Code Name', defaultHeader: 'Code' },
  { key: 'clientMarkedCompleted', label: 'Client Marked', defaultHeader: 'Marked' },
  { key: 'isHighPriority', label: 'High Priority', defaultHeader: 'Urgent' },
  { key: 'isClosed', label: 'Closed', defaultHeader: 'Closed' },
  { key: 'id', label: 'ID', defaultHeader: 'ID' }
]
